import React from 'react';
import { Modal, TouchableWithoutFeedback, StyleSheet } from 'react-native';

import { Box } from '@components/Restyle';
import { useSlidePanelMotion } from '@components/Web/Navigator/SlideInPanel.web';

interface OverlayProps {
  visible: boolean;
  onDismiss?: () => void;
  children?: React.ReactNode;
  dismissable?: boolean;
  centered?: boolean;
  /**
   * 'fade' (default) fades the whole layer. 'slide-panel' fades only the
   * backdrop and leaves the content still, for a side panel that animates
   * itself in and out via SlidePanelPresence (TA-10891 #13/#15).
   */
  animationType?: 'fade' | 'slide-panel';
}

export const Overlay: React.FC<OverlayProps> = ({
  visible,
  onDismiss,
  children,
  dismissable = true,
  centered = false,
  animationType = 'fade',
}) => {
  const isSlidePanel = animationType === 'slide-panel';
  const { backdrop } = useSlidePanelMotion();
  return (
    <Modal
      visible={visible}
      transparent
      animationType={isSlidePanel ? 'none' : 'fade'}
      onRequestClose={dismissable ? onDismiss : undefined}>
      <TouchableWithoutFeedback
        onPress={dismissable ? onDismiss : undefined}
        disabled={!dismissable}>
        <Box
          style={[
            styles.overlay,
            centered && styles.centered,
            isSlidePanel && backdrop,
          ]}>
          <TouchableWithoutFeedback onPress={(e) => e.stopPropagation()}>
            <Box flex={centered ? undefined : 1}>{children}</Box>
          </TouchableWithoutFeedback>
        </Box>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
